var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512.14 512.14",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    d: "m186.45 432.62h141.24v52.966h-141.24z",
    fill: "#2c3e50",
    style: {},
    "data-original": "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    d: "m513.07 370.83v30.455c1.261 20.815-14.506 38.749-35.31 40.165h-441.38c-20.805-1.417-36.571-19.351-35.31-40.165v-30.455h512z",
    fill: "#556080",
    style: {},
    "data-original": "#556080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "M513.071 40.236v330.593h-512V40.236C-.19 19.421 15.576 1.487 36.381.071H477.76c20.805 1.416 36.571 19.35 35.311 40.165z",
    fill: "#dbd2c1",
    style: {},
    "data-original": "#3d324c"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    d: "m168.8 81.373v109.64a3.434 3.434 0 0 1-3.531 3.266h-98.869a3.363 3.363 0 0 1-3.531-3.178v-109.73l50.229-45.021a4.265 4.265 0 0 1 5.473 0l50.229 45.021z",
    fill: "#f3d55b",
    style: {},
    "data-original": "#f3d55b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "M115.829 229.588v52.966l-44.138 26.483-1.236.794a52.141 52.141 0 0 1-7.592-27.277c.001-29.253 23.714-52.966 52.966-52.966z",
    fill: "#f0c419",
    style: {},
    "data-original": "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "m168.8 282.55a52.471 52.471 0 0 1-15.537 37.429l-37.429-37.429v-52.966c29.252 1e-3 52.966 23.714 52.966 52.966z",
    fill: "#ff5364",
    style: {},
    "data-original": "#ff5364"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    d: "m153.26 319.98a52.889 52.889 0 0 1-82.803-10.151l1.236-0.794 44.138-26.483 37.429 37.428z",
    fill: "#24ae5f",
    style: {},
    "data-original": "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "m292.38 44.209h17.655a8.828 8.828 0 0 1 8.828 8.828v105.93h-35.31v-105.93a8.826 8.826 0 0 1 8.827-8.827z",
    fill: "#f0c419",
    style: {},
    "data-original": "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "m360.62 88.346h22.422a6.444 6.444 0 0 1 6.444 6.444v64.177h-35.31v-64.176a6.445 6.445 0 0 1 6.444-6.445z",
    fill: "#ff5364",
    style: {},
    "data-original": "#ff5364"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    d: "m429.89 114.83h25.114a5.094 5.094 0 0 1 5.094 5.094v39.044h-35.302v-39.044a5.095 5.095 0 0 1 5.094-5.094z",
    fill: "#24ae5f",
    style: {},
    "data-original": "#24ae5f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "m248.24 309.04a8.829 8.829 0 0 1-6.241-15.069l31.656-31.656c10.482-10.002 26.974-10.002 37.455 0l10.337 10.346a8.828 8.828 0 0 0 12.482 0l36.829-36.829c10.479-10.001 26.968-10.001 37.447 0l10.346 10.346a8.828 8.828 0 0 0 12.482 0l31.656-31.647a8.828 8.828 0 0 1 12.483 12.483l-31.656 31.656c-10.354 10.309-27.093 10.309-37.447 0l-10.346-10.355a9.013 9.013 0 0 0-12.482 0l-36.829 36.829c-10.342 10.338-27.105 10.338-37.447 0l-10.346-10.346a9.013 9.013 0 0 0-12.482 0l-31.656 31.656a8.827 8.827 0 0 1-6.241 2.586z",
    fill: "#ff5364",
    style: {},
    "data-original": "#ff5364"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    d: "m142.31 476.76h229.52c14.626 0 26.483 11.857 26.483 26.483v8.828h-282.48v-8.828c0-14.626 11.857-26.483 26.483-26.483z",
    fill: "#556080",
    style: {},
    "data-original": "#556080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "m186.45 106a8.829 8.829 0 0 1-5.888-2.251l-64.733-57.944-64.733 57.944c-3.638 3.197-9.173 2.866-12.404-0.743s-2.951-9.146 0.628-12.41l67.902-60.787a13.011 13.011 0 0 1 17.055-0.132l68.061 60.91a8.829 8.829 0 0 1-5.888 15.413z",
    fill: "#ff5364",
    style: {},
    "data-original": "#ff5364"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    transform: "translate(-1)",
    d: "M62.864 90.2a8.828 8.828 0 0 1-8.828-8.828V57.45a8.828 8.828 0 0 1 17.656 0v23.923a8.829 8.829 0 0 1-8.828 8.827z",
    fill: "#ff5364",
    style: {},
    "data-original": "#ff5364"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1)",
    d: "m468.93 167.8h-203.04c-14.626 0-26.483-11.857-26.483-26.483v-105.93a8.828 8.828 0 0 1 17.656 0v105.93a8.828 8.828 0 0 0 8.828 8.828h203.03a8.828 8.828 0 0 1 0 17.655zm0 176.55h-203.04c-14.626 0-26.483-11.857-26.483-26.483v-105.93a8.828 8.828 0 0 1 17.656 0v105.93a8.828 8.828 0 0 0 8.828 8.828h203.03a8.828 8.828 0 0 1 0 17.654z",
    fill: "#b49aca",
    style: {},
    "data-original": "#b49aca"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.1bfd58aab4f1be4804e1e8435712c271.svg";
export { ForwardRef as ReactComponent };